import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

/* funcion ejecucion api */

export const useTypeIncomeService = () => {
  const { Token } = useUserSuperEmpresa();

  const PostTypeIncomes = async (params = {}) => {
    try {
      const { data } = await api.post("/typeincomes/store", params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });

      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

  const GetTypeIncomes = async (params = {}) => {
    try {
      const { data } = await api.get("/typeincomes", {
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });

      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };
  const UpdateTypeIncomes = async (id, params = {}) => {
    try {
      const { data } = await api.post(`/typeincomes/update/${id}`, params, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al actualizar ingreso";
    }
  };


  const DeleteTypeIncomes = async (id) => {
    try {
      const { data } = await api.delete(`/typeincomes/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al eliminar ingreso";
    }
  };

  return { PostTypeIncomes, GetTypeIncomes, DeleteTypeIncomes, UpdateTypeIncomes };
}


/* funciones de llamados */

export const useTypeIncomes = () => {
  const { Token } = useUserSuperEmpresa();
  const { GetTypeIncomes} = useTypeIncomeService();
  const [incomeTypes, setIncomeTypes] = useState([]);
  const [loadings, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIncomeTypes = async () => {
      try {
        const data = await GetTypeIncomes();
        setIncomeTypes(data);
      } catch (err) {
        setError(err.response?.data?.message || "Error al obtener ingresos");
      } finally {
        setLoading(false);
      }
    };

    fetchIncomeTypes();
  }, [Token]);

  return { incomeTypes, loadings, error };
};
